import React from 'react';
import { Chip, styled } from '@mui/material';

const StyledChip = styled(Chip)(({ theme }) => ({
  height: '20px',
  fontSize: '0.65rem',
  marginRight: '4px',
  backgroundColor: 'rgba(0, 128, 255, 0.1)',
  border: '1px solid rgba(0, 128, 255, 0.3)',
  color: 'rgba(0, 64, 128, 0.9)',
  borderRadius: '4px',
  '& .MuiChip-label': {
    padding: '0 6px',
    fontWeight: 500,
  },
}));

/**
 * ExternalTaskChip - Displays a styled chip to indicate an external task
 *
 * @param {Object} props
 * @param {string} props.size - The size of the chip ('small' or 'medium')
 * @param {string} props.className - Additional CSS class to apply to the chip
 * @returns {JSX.Element} The External chip component
 */
const ExternalTaskChip = ({ size = 'small', className }) => {
  return <StyledChip size={size} label="External" className={className} />;
};

export default ExternalTaskChip;
